<template>
	<section>
		<div class="d-sm-flex align-items-center justify-content-between mb-4">
	        <h1 class="h3 mb-0 text-gray-800">Histórico da gravação</h1>

	        <router-link :to="{name: 'RamalView', params: {get: ramal_id} }">
	        	<button class="btn btn-sm btn-success">Voltar</button>
	        </router-link>
	    </div>

	    <div class="row">
			<div class="col-md-12">
				<img :src="logotipo" style="width: 16%; margin-left: 42%;">
			</div>
		</div>

		<player ref="wavesurfer" :audio_hash="gravacao.file" />

		<hr>

		<div class="d-sm-flex justify-content-between mb-3">
			<div class="p-2 mr-1">
				<b>ID: </b> {{ gravacao.id }}
			</div>

			<div class="p-2 mr-1">
				<b>Protocolo: </b> {{ gravacao.protocolo }}
			</div>

			<div class="p-2 mr-1">
				<b>Origem: </b> {{ Phone(gravacao.origem) }}
			</div>

			<div class="p-2 mr-1">
				<b>Data: </b> {{ convert_hor(gravacao.created_at) | moment("DD/MM/YYYY") }}
			</div>

			<div class="p-2 mr-1">
				<b>Hora: </b> {{ convert_hor(gravacao.created_at) | moment("HH:mm:ss") }}
			</div>
		</div>

		<div class="row">
	    	<table class="table table-striped table-hover table-sm table-responsive-xl">
	    		<thead align="center">
	    			<th @click="orderBy('id')"         >ID         <font-awesome-icon v-if="direction.by == 'id'"         :icon="order_icon" size="xs" /></th>
	    			<th @click="orderBy('data')"       >DATA       <font-awesome-icon v-if="direction.by == 'data'"       :icon="order_icon" size="xs" /></th>
	    			<th @click="orderBy('hora')"       >HORA       <font-awesome-icon v-if="direction.by == 'hora'"       :icon="order_icon" size="xs" /></th>
	    			<th @click="orderBy('prioridade')" >PRIORIDADE <font-awesome-icon v-if="direction.by == 'prioridade'" :icon="order_icon" size="xs" /></th>
	    			<th @click="orderBy('status')"     >STATUS     <font-awesome-icon v-if="direction.by == 'status'"     :icon="order_icon" size="xs" /></th>
	    			<th @click="orderBy('resumo')"     >RESUMO     <font-awesome-icon v-if="direction.by == 'resumo'"     :icon="order_icon" size="xs" /></th>
	    			<th></th>
	    		</thead>

	    		<transition mode="out-in" name="leftIn">
					<tbody v-if="gravacoes" align="center">
		    			<tr v-for="(row, index) in gravacoes.data" :key="index">
							<td>{{ row.id }}</td>
							<td>{{ convert_hor(row.created_at) | moment("DD/MM/YYYY") }}</td>
							<td>{{ convert_hor(row.created_at) | moment("HH:mm:ss") }}</td>
							<td><font-awesome-icon icon="flag" :class="priority_color(row.prioridade)" /></td>
							<td>{{ get_status(row.status) }}</td>
							<td>{{ row.resumo }}</td>
							<td><font-awesome-icon icon="eye" class="info pointer" @click="view(row)" /></td>
						</tr>
		    		</tbody>
		    		<Loading v-else />
				</transition>
	    	</table>
	    </div>

	    <controls :data="constrol_data" @refresh="navigate"  @alert="show_alert" />
		<modal :block="true" :gravacao="modal_data" @alert="show_alert" />
	</section>
</template>

<script>
	import api      from "@/mixins/api.js"
	import replace  from "@/mixins/replace.js"
	import controls from "@/components/Tools/Table_Control.vue"
	import player   from "@/components/Tools/Player.vue"
	import modal    from "@/components/Modal/Views/Gravacao.vue"

	export default {
		name: "Gravacao",
		mixins: [api, replace],
		components: { controls, player, modal },

		data() { 
			return {
				gravacao: {},
				gravacoes: null,
				constrol_data: {},
				modal_data: {},
				pagination: "10?",
				direction: { order: "desc", by: "id" },
			}
		},

		computed: {
			logotipo() { 
				return this.$store.state.config.logotipo;
			},

			ordenation() {
				return `order=${this.direction.order}&by=${this.direction.by}`;
			},

			order_icon() {
				return ( this.direction.order == "asc" ) ? "arrow-up" : "arrow-down";
			},

			ramal_id() {
				return this.$attrs.ramal;
			}
		},

		created() {
			this.get_gravacao();
			this.get_data();
		},

		methods: {
			async get_gravacao() {
				const response = await this.GET("Gravacao", this.$route.params.gravacao);

				if ( response.status == 'success' ){
					this.gravacao = response.result;
				}
			},

			async get_data() {
				const response = await this.GET("Gravacao/Historico", `Paginate/${this.pagination}${this.ordenation}&where=gravacao&value=${this.$route.params.gravacao}`);

				if ( response.status == "success" ){
					this.gravacoes = response.result;
				}
				this.constrol_data = {
					current_page: this.gravacoes.current_page,
					last_page:    this.gravacoes.last_page,
					per_page:     this.gravacoes.per_page,
					total:        this.gravacoes.total,
				}
			},

			orderBy(payload) {
				if ( payload == this.direction.by ) {
					this.direction.order = ( this.direction.order == 'desc' ) ? 'asc' : 'desc';
				}else{
					this.direction.by = payload;
				}

				this.get_data();
			},

			navigate(payload) {
				this.pagination = payload;
				this.get_data();
			},

			convert_hor(payload){
				var nova_hora = new Date(payload);
				nova_hora.setHours(nova_hora.getHours()-3);
				return nova_hora;
			},

			show_alert(payload) {
				this.alert.type = (payload.status == "success") ? "alert-success" : "alert-danger";
				this.alert.msg  = payload.result;

				$("#modal-gravacao").modal('hide');
				this.get_data();
				$("#app-alert").show();
				setTimeout(() => $("#app-alert").hide(), 3000 );
			},

			view(payload) {
				this.modal_data = payload;
				$("#modal-gravacao").modal();
			},
		},
	}
</script>